"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.userRaceSubscription = graphql_tag_1.default("subscription userRace {\n  userRace {\n    currentQuestion {\n      title\n      selectedOptions\n      sentAt\n      options\n      index\n    }\n    currentSpeed\n    currentServerTime\n    startedAt\n    penaltyTime\n  }\n}");
